import getReduxSelector from 'modules/redux/selectors/get'
import {
  FEATURED_DEALS_KEY,
  FEATURED_DEALS_PATH
} from 'modules/featured-deals/redux/constants'

const getSaleTypeFeaturedDealsSelect = state => {
  const path = FEATURED_DEALS_PATH[FEATURED_DEALS_KEY.SALE_TYPE]
  return getReduxSelector(path)(state)
}

export default getSaleTypeFeaturedDealsSelect
